import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { getBaseUrl } from '@shared/helpers/get-base-url-helper';

@Component({
  selector: 'app-data-sheet-tabs',
  templateUrl: './data-sheet-tabs.component.html',
  styleUrls: ['./data-sheet-tabs.component.scss'],
})
export class DataSheetTabsComponent implements OnChanges, OnDestroy {
  @Input() queryParams?: Object;
  @Input() showOnlyFirstTab: boolean = false;
  @Input() showCollectionsTab: boolean = false;
  @Input() tabPanel!: MatTabNavPanel;

  baseUrl = '';
  activeLinkIndex = 0;

  subs = new Subscription();

  navLinks: {
    label: string;
    link: string;
    index: number;
  }[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnChanges(): void {
    this.baseUrl = getBaseUrl(this.router.url, this.route.snapshot);
    this.navLinks = [
      {
        label: 'SHARED.TITLE.BASIC_DATA',
        link: '',
        index: 0,
      },
    ];

    if (!this.showOnlyFirstTab) {
      this.navLinks.push({
        label: 'SHARED.TITLE.IMAGES',
        link: '/images',
        index: 1,
      });
      if (this.showCollectionsTab) {
        // TODO
        this.navLinks.push({
          label: 'SHARED.TITLE.COLLECTIONS',
          link: '/collections',
          index: 2,
        });
      }
    }

    this.navigate(this.router.url);
    this.subs.add(
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.navigate(e.urlAfterRedirects);
        }
      })
    );
  }

  navigate(url: string): void {
    const childUrl = url.split('?')[0].split(this.baseUrl)[1];

    switch (childUrl) {
      case '':
        this.activeLinkIndex = 0;
        break;
      case '/images':
        this.activeLinkIndex = 1;
        break;
      case '/collections':
        this.activeLinkIndex = 2;
        break;
      default:
        this.activeLinkIndex = -1;
    }
  }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }
}
